/* product photos: whole piece visible and centred; the empty sides take the colour of the photo's own edges */
(function () {
  function fill(img) {
    var box = img.closest && img.closest('.fk26-card__media, .product-card-wrapper .card:not(.card-layout--horizontal) .card-media');
    if (!box || box.dataset.fkfill) return;
    var u = img.currentSrc || img.src;
    if (!u || /data:|transparent/.test(u) || !window.createImageBitmap || !window.OffscreenCanvas) return;
    box.dataset.fkfill = '1';
    fetch(u.replace(/([?&])width=\d+/, '$1width=48')).then(function (r) { return r.blob(); }).then(createImageBitmap).then(function (bm) {
      var W = bm.width, H = bm.height, c = new OffscreenCanvas(W, H), x = c.getContext('2d');
      x.drawImage(bm, 0, 0);
      var d = x.getImageData(0, 0, W, H).data;
      function avg(pts) {
        var r = 0, g = 0, b = 0;
        pts.forEach(function (p) { var i = (p[1] * W + p[0]) * 4; r += d[i]; g += d[i + 1]; b += d[i + 2]; });
        var n = pts.length; return 'rgb(' + (r / n | 0) + ',' + (g / n | 0) + ',' + (b / n | 0) + ')';
      }
      function col(xx) { var a = []; for (var y = 0; y < H; y++) a.push([xx, y]); return a; }
      function row(y) { var a = []; for (var xx = 0; xx < W; xx++) a.push([xx, y]); return a; }
      var bw = box.getBoundingClientRect(), tall = H / W > (bw.height / bw.width || 1.2);
      box.style.setProperty('--fkfill', tall
        ? 'linear-gradient(to right, ' + avg(col(0).concat(col(1))) + ' 0 50%, ' + avg(col(W - 1).concat(col(W - 2))) + ' 50% 100%)'
        : 'linear-gradient(to bottom, ' + avg(row(0).concat(row(1))) + ' 0 50%, ' + avg(row(H - 1).concat(row(H - 2))) + ' 50% 100%)');
    }).catch(function () {});
  }
  function all() {
    document.querySelectorAll('.fk26-card__media img, .product-card-wrapper .card-media img.product-card-featured-image').forEach(function (i) {
      if (i.complete && i.naturalWidth) fill(i);
    });
  }
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') fill(e.target); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(all, 200); }).observe(document.documentElement, { childList: true, subtree: true });
})();
